<mat-icon
  *ngIf="total"
  [class.grey]="!allResolved()"
  [class.green]="allResolved()"
  [matTooltip]="getToolTipText()"
  [matTooltipShowDelay]="toolTipDelay"
  [matTooltipPosition]="tooltipPosition"
  >{{ getIcon() }}</mat-icon
>
